export default {"src":"/fly/_next/static/media/py.0564b87d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};